export default class DataLayer {
    private static instance: DataLayer
    /**
     * Tipos de eventos: pre-cadastro, msg-cadastro, vpageview, download-nfs, msg-remocao-nf (V 1.0.22)
     */
    public event = ''
    /**
     * Codigo de usuario ex: T0694854241
     */
    public userId = ''
    /**
     * navigation, service, html
     */
    public type = ''
    /**
     * Mensagem de retorno
     */
    public msg = ''
    /**
     * sucess, error
     */
    public status = ''
    /**
     * path da pagina atual
     */
    public vpageurl = ''

    /**
     * Objeto com os dados variaveis para enviar em cada evento ex: {"vpageurl":"/home", "outro":"outra variavel""}
     */
    public data: any = {}

    constructor(
        event: string,
        userId: string,
        type: string,
        msg: string,
        status: string,
        vpageurl: string,
        data?: any
    ) {
        this.event = event
        this.userId = userId
        this.type = type
        this.msg = msg
        this.status = status
        this.vpageurl = vpageurl
        this.data = data
    }

    /**
     * Método estático que controla o acesso à única instância do DTO
     *
     */
    public static getInstance(
        event: string,
        userId: string,
        type: string,
        msg: string,
        status: string,
        vpageurl: string,
        data?: any
    ): DataLayer {
        if (!DataLayer.instance) {
            DataLayer.instance = new DataLayer(event, userId, type, msg, status, vpageurl, data)
        }

        return DataLayer.instance
    }
    /**
     * Método para criar uma instancia nova do DataLayer
     */
    public static createDataLayer(): DataLayer {
        DataLayer.instance = new DataLayer('', '', '', '', '', '')
        return DataLayer.instance
    }
}
